/**
 * @module FE-CU14_警報確認画面_センサーコンポーネント
 */
import ListPanel from '@/components/listPanel/ListPanel.vue';
import PCFooter from '@/components/footer/PCFooter.vue';

export default {
  name: 'AlertConfirmation',
  components: {
    ListPanel,
    PCFooter,
  },
  props: {
    panelTitle: {
      type: Object,
      required: false,
    },
    displayAreaList: {
      type: Array,
      required: false,
    },
    areaType: {
      type: Number,
      default: 1,
      required: false,
    },
    areaName: {
      type: String,
      default: '',
      required: false,
    },
    securityAreaList: {
      type: Array,
      required: false,
    },
    notificationImage: {
      type: String,
      required: false,
    },
    notificationTitle: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      typeLock: 1, //いずれグローバルな定数化
      typeAlert: 2,
    };
  },
};
